import { render, staticRenderFns } from "./LenderFees.vue?vue&type=template&id=f48c5836&scoped=true&"
import script from "./LenderFees.vue?vue&type=script&lang=js&"
export * from "./LenderFees.vue?vue&type=script&lang=js&"
import style0 from "./LenderFees.vue?vue&type=style&index=0&id=f48c5836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48c5836",
  null
  
)

export default component.exports